<div class="flex items-center justify-between h-32 px-4 relative">
    <!-- Back Arrow -->
    <div class="flex items-center gap-2">
        @if (showBackArrow) {
            <button (click)="onBackArrowClick()"
                    aria-label="Go back"
                    class="p-2 rounded hover:bg-gray-100 dark:hover:bg-gray-700"
                    pTooltip="Go back"
                    title="Go back"
                    tooltipPosition="right">
                <svg class="h-8 w-8 text-gray-800 dark:text-gray-100"
                     fill="none"
                     stroke="currentColor"
                     stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 19l-7-7 7-7" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
        }


    </div>

    <!-- Centered Logo -->
    <div class="flex items-center justify-center absolute inset-0 pointer-events-none">
        <div class="pointer-events-auto">
            <img src="/assets/mb-logo.png" alt="MB Logo" class="mb-star">
        </div>
    </div>


    <div class="flex items-center relative gap-3">
        <!-- Notification Bell -->
        @if (showNotificationBell) {
            <div class="relative mx-4 flex-shrink-0
            flex-none"
            >
            <button class="w-10 h-10 p-2
                    flex items-center justify-center
                    rounded hover:bg-gray-100 dark:hover:bg-gray-700"
                    (click)="onNotificationBellClick()"
                    title="Notifications"
                    pTooltip="Notifications"
                    tooltipPosition="left"
                    aria-label="Notifications">
                <img src="/assets/images/notification.svg"
                     alt="Notifications"
                     class="w-6 h-6">
                <!-- Badge -->
                @if (unreadNotificationCount > 0) {
                    <span
                      class="absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2
                     inline-flex items-center justify-center
                     h-4 w-4 rounded-full text-xs font-bold text-white"
                      style="background-color:#1998FC;">
              {{ unreadNotificationCount }}
            </span>
                }
            </button>
            </div>
        }


        <!-- Dropdown Menu -->
        <div
                class="flex-grow
               basis-40 md:basis-48 lg:basis-56
               max-w-[10rem]  md:max-w-[12rem]  lg:max-w-[14rem]">
            <p-select
                    [options]="studios"
                    [(ngModel)]="selectedStudioId"
                    optionLabel="name"
                    optionValue="id"
                    (onChange)="onStudioChange()"
                    placeholder="Select a Studio"
                    styleClass="w-full truncate"
                    [appendTo]="'body'"
            ></p-select>
        </div>
    </div>

</div>

<!-- Toast -->
<p-toast position="top-right"></p-toast>
